/**
 * Route and copy for the client pay-run normalisation onboarding tool.
 */

export const CLIENT_PAY_NORMALISATION_BASE_PATH =
  "/onboarding/client-pay-normalisation";

/** Product-facing title shown in navigation and the page header. */
export const CLIENT_PAY_NORMALISATION_DISPLAY_NAME =
  "Client pay-run normalisation";

/** v1 catalogue id for MYOB IMS (Appendix D / Api #1098). */
export const MYOB_IMS_IMPORT_SOURCE_ID = "MYOB IMS";

/** Parser profile for MYOB IMS (matches Api catalogue binding). */
export const MYOB_IMS_PARSER_PROFILE_ID = "myob_ims_payslip_nz_v1";

const PARSER_PROFILE_ID_BY_IMPORT_SOURCE: Record<string, string> = {
  [MYOB_IMS_IMPORT_SOURCE_ID]: MYOB_IMS_PARSER_PROFILE_ID,
  MYOB_IMS: MYOB_IMS_PARSER_PROFILE_ID,
};

/** Fallback when older Api responses omit ``parserProfileId``. */
export function parserProfileIdForImportSource(importSourceId: string): string | null {
  return PARSER_PROFILE_ID_BY_IMPORT_SOURCE[importSourceId] ?? null;
}

/** File dropzone accept filter for MYOB IMS combined payslip PDF (R-APP-2). */
export const CLIENT_PAY_NORMALISATION_PDF_ACCEPT = ".pdf";

/** Align with Pacific.Agentic.Api `MAX_PDF_UPLOAD_BYTES` (#1098). */
export const CLIENT_PAY_NORMALISATION_MAX_PDF_BYTES = 20 * 1024 * 1024;

export const CLIENT_PAY_NORMALISATION_PDF_SUB_INSTRUCTION =
  "One combined PDF with all employee payslips for the pay period. Text-based export only — not a scan.";

/** Core API paths (OpenAPI operation ids in Api #1098 / PR #1110). */
export const CLIENT_PAY_NORMALISATION_API_PATHS = {
  importSources: "/api/v1/onboarding/client-pay-normalisation/import-sources",
  runs: "/api/v1/onboarding/client-pay-normalisations",
  run: (runId: string) =>
    `/api/v1/onboarding/client-pay-normalisations/${encodeURIComponent(runId)}`,
  artifact: (runId: string, artifactFileName: string) =>
    `/api/v1/onboarding/client-pay-normalisations/${encodeURIComponent(runId)}/artifacts/${encodeURIComponent(artifactFileName)}`,
} as const;
